import { MoneySchema } from "@redotech/money";
import { trackerStatusSchema } from "@redotech/order-tracking-common/order-tracking-tracker-status-definition";
import { trackingLocationSchema } from "@redotech/order-tracking-common/order-tracking-tracking-location-definition";
import {
  OrderTrackingOrderFulfillmentStatus,
  orderTrackingOrderSources,
  OrderTrackingShipmentStatus,
} from "@redotech/order-tracking-common/order-tracking-types";
import { trackingPageSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum TrackingCodePageStatus {
  LOGIN_REQUIRED = "login_required",
  SUCCESS = "success",
}

const trackingCodePageLineItemSchema = z.object({
  name: z.string().nullish(),
  variantTitle: z.string().nullish(),
  quantity: z.number(),
  undiscountedPrice: MoneySchema.nullish(),
  discountedPrice: MoneySchema.nullish(),
  imageUrl: z.string().nullish(),
});

const trackingCodePageShipmentSchema = z.object({
  status: createEnum(OrderTrackingShipmentStatus),
  trackingCode: z.string(),
  carrier: z.string().nullish(),
  estimatedDeliveryAt: z.coerce.date().nullish(),
  deliveredAt: z.coerce.date().nullish(),
  updatedAt: z.coerce.date(),
  trackingEvents: z.array(
    z.object({
      timestamp: z.coerce.date(),
      status: trackerStatusSchema,
      message: z.string(),
      location: trackingLocationSchema.nullish(),
    }),
  ),
  lineItems: z.array(trackingCodePageLineItemSchema),
});

const trackingCodePageOrderSchema = z.object({
  fulfillmentStatus: createEnum(OrderTrackingOrderFulfillmentStatus),
  currency: z.string(),
  source: createEnum(orderTrackingOrderSources),
  shipment: trackingCodePageShipmentSchema,
});

export const getTrackingPageByCode = {
  name: "getTrackingPageByCode" as const,
  input: z.object({ trackingCode: z.string().trim().min(1).max(128) }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal(TrackingCodePageStatus.LOGIN_REQUIRED) }),
    z.object({
      status: z.literal(TrackingCodePageStatus.SUCCESS),
      pageSettings: trackingPageSettingsSchema,
      order: trackingCodePageOrderSchema,
    }),
  ]),
};

export type GetTrackingPageByCodeOutput = z.infer<
  (typeof getTrackingPageByCode)["output"]
>;
